"use client";
import SarahAIGraphs from "../../../components/LeadCenter/LeadDetails/DetailTabs/SarahAI/SarahAIGraphs";
export default function SarahAIPage() {

  return <SarahAIGraphs />;
}
